import { jsx as t } from "react/jsx-runtime";
import { useState as l } from "react";
import { FormTextField as f } from "./index10.mjs";
import { isPositiveNumber as P, isNotLongerThanOTP as c } from "./validators.mjs";
import { InputAdornment as g } from "@mui/material";
import { Loader as h } from "./index40.mjs";
import { FORM_OTP_DEFAULT_VALIDATION as v } from "./constants9.mjs";
const V = ({
  label: m,
  rules: d = v,
  isLoading: p,
  onChange: r,
  value: o,
  defaultValue: a,
  ...e
}) => {
  const [s, u] = l(a);
  return /* @__PURE__ */ t(
    f,
    {
      label: m,
      rules: d,
      value: o !== void 0 ? o : s,
      onChange: (i) => {
        if (o === void 0) {
          const n = i.target.value.trim();
          (!n || P(n) && c(n)) && u(n);
        }
        r && r(i);
      },
      ...e,
      InputProps: {
        ...e.InputProps,
        endAdornment: p ? /* @__PURE__ */ t(g, { position: "end", children: /* @__PURE__ */ t(h, { size: "sm" }) }) : e.InputProps?.endAdornment,
        inputProps: {
          ...e.inputProps,
          pattern: "[0-9]*",
          inputMode: "numeric"
        }
      }
    }
  );
};
export {
  V as FormOtpCodeField
};
//# sourceMappingURL=index8.mjs.map
